/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const JobOutcomeTriggerAudience = core.serialization.enum_(["originator", "all"]);
